<button
	mat-fab
	class="scroll-to-top"
	[ngClass]="{ 'show-scrollTop': windowScrolled }"
	color="primary"
	(click)="scrollToTop()"
>
	<ic-icon [icon]="keyboardArrowUpIcon"></ic-icon>
</button>
